import cn from 'classnames';

import stylesDesktop from './desktop.css';

type THelperParams = {
    className: string | undefined;
    isSticky: boolean;
    sticky: boolean | undefined;
};

export const wrapperStickedClassNameHelperDesktop = ({ className, sticky }: THelperParams) =>
    cn(className, { [stylesDesktop.sticky]: sticky });
